import {message} from 'antd';

/**
 * Descarga un recurso desde una URL, extrae el filename del header Content-Disposition
 *
 * @param {Object}   options
 * @param {string}   options.url               - URL completa al recurso a descargar
 * @param {Object}   options.headers           - Cabeceras a enviar en el fetch
 * @param {string}   options.defaultFileName   - Nombre de archivo por defecto si no viene en el header
 * @param {Function} [options.onStart]         - (Opcional) callback que se llama antes de iniciar la descarga
 * @param {Function} [options.onFinish]        - (Opcional) callback que se llama al terminar (success o error)
 */
export async function downloadFile({
                                       url,
                                       headers,
                                       defaultFileName,
                                       onStart = () => {},
                                       onFinish = () => {},
                                   }) {
    try {
        onStart();
        const response = await fetch(url, { method: 'GET', headers });

        if (!response.ok) {
            const errJson = await response.json();
            const { message } = errJson;
            throw new Error(`Error: ${message}`);
        }

        const cd = response.headers.get('Content-Disposition')
            || response.headers.get('content-disposition')
            || '';
        let filename = defaultFileName;
        const match = cd.match(/filename\*?=(?:UTF-8'')?["']?([^;"']+)["']?/i);
        if (match && match[1]) {
            filename = decodeURIComponent(match[1]);
        }

        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(downloadUrl);

    } catch (err) {
        message.error(err.message)
    } finally {
        onFinish();
    }
}
